export const CONFIG = {
  API_SERVER: "https://api.afrac.chichinacds.com.co",
  COMPANY: 'AFRAC',
  CITY: 'VILLAVICENCIO'
}
